import type { SVGProps } from 'react'

export const BarChart = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18 19H6.52941C5.68474 19 5 18.3153 5 17.4706V6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 15L13 15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 12L16 12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 9L17 9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
